export const ADD_SUBJECT_REQUEST = 'ADD_SUBJECT_REQUEST'
export const ADD_SUBJECT_SUCCESS = 'ADD_SUBJECT_SUCCESS'
export const ADD_SUBJECT_FALIURE = 'ADD_SUBJECT_FALIURE'
